var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection44(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 22S56 28 54 30.2c-.5.6 9.5 6.6 9.5 6.6s-9.2 3.1-11.4 2.7c2.6 4.4 4.6 5.2 6.8 9.6-4.1 0-8-1.3-12-1.4.2 4.7 1 6.7 1.2 13.2-2.6-1.6-5-5.4-10-9.3-.8.5-9.1 9.7-9.1 9.7l-2-13.2s-10.4 2.2-13.4 3.3c2.2-5.1 5.2-7.4 6.9-11.1-3.9-2.8-7-5.6-11.5-8.4 4.4-2.2 9.2-1.8 13.2-3.2a53 53 0 01-4.8-14.4c4.4 1.7 7.3 5 11.7 6.6 1.6-3.8 2.3-9 3.8-12.8 2.3 3.9 3.6 7.3 5.9 11.2 2.1-3.5 5.6-6.6 9.5-9.7.7 5.5.6 7 0 13.7 5.7-1.7 14-1.3 14-1.3z",
    fill: "#FFD15A",
    stroke: "#FFD15A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3 38a51 51 0 015.1 4.6c1.6 1.6 3.9 1 5-.7L46 31.5c2.4-3.4-3.2-6.6-5.6-3.3L33 38.7l5-.7a51 51 0 00-5-4.6c-3.3-2.6-7.8 2-4.6 4.5z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 26.4C21.1 22.2 20 18 19 13.8c-.5-2-3.6-1.1-3.1.9.9 4.2 2 8.3 3.3 12.5.7 2 3.8 1.1 3.1-.8z",
    fill: "#009AFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 34c3.2 2.2 6.4 4.5 9.5 7 1.6 1.3 3.9-1 2.3-2.3-3.3-2.6-6.7-5.2-10.2-7.5-1.7-1.2-3.4 1.6-1.6 2.7zM25 51c.5 3.6 1.3 7.2 2 10.8.3 2 3.4 1.1 3-.9l-2-10.8c-.3-2-3.4-1.2-3 .9zM38.7 54.9c3 2.2 5.4 5 8.3 7.1 1.6 1.3 3.9-1 2.3-2.2-3.1-2.4-5.8-5.3-9-7.7-1.6-1.3-3.1 1.6-1.6 2.8z",
    fill: "#1E2882"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9 50c3.3.6 6.7 1 10 1.2 2.1.1 2.1-3.1 0-3.2-3-.1-6.1-.5-9.2-1-2-.5-2.9 2.6-.8 3z",
    fill: "#009AFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 18.6c1.2-3.1 2.5-6.3 4-9.3.9-1.9-1.9-3.5-2.8-1.7-1.6 3.4-3 6.7-4.3 10.2-.7 2 2.4 2.8 3.1.8z",
    fill: "#F68559"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 52.8c2 0 2-3.2 0-3.2s-2 3.2 0 3.2zM42.1 17.9c2-2.8 4.8-4.9 7.3-7.1 1.5-1.4-.7-3.7-2.3-2.3-2.7 2.5-5.5 4.8-7.7 7.8-1.3 1.6 1.5 3.2 2.7 1.6z",
    fill: "#1E2882"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection44);
export default __webpack_public_path__ + "static/media/section4-4.c8d9dcc986e5887cb3ccaa770b0ca122.svg";
export { ForwardRef as ReactComponent };